module.exports = __webpack_public_path__ + "img/workbenchPosition.92f04471.svg";